import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { FormsModule } from "@angular/forms";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReviewParsedCvDialogComponent } from "./review-parsed-cv-dialog.component";
import {NzModalModule} from "ng-zorro-antd/modal";
import {NzButtonModule} from "ng-zorro-antd/button";
import {EducationsInputModule} from "../../common-componnets/educations-input/educations-input.module";
import {TrackRecordsInputModule} from "../../common-componnets/track-record-input/track-records-input.module";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [ReviewParsedCvDialogComponent],
    imports: [
    CommonModule, 
    NzModalModule, 
    NzButtonModule, 
    EducationsInputModule, 
    TrackRecordsInputModule, 
    TranslateModule,
    FormsModule,
    NzInputModule,
    NzFormModule,
    NzGridModule,
    NzSelectModule,
    NzSpinModule
  ],
  exports: [ReviewParsedCvDialogComponent]
})
export class ReviewParsedCvDialogModule {}
